export * from '@primeuix/themes/lara/carousel';
export { default } from '@primeuix/themes/lara/carousel';
